import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';
import { Store } from '@ngrx/store';
import { Subject, filter, firstValueFrom, take, takeUntil } from 'rxjs';
import { SettingsActions } from 'src/app/store/settings/actions';

import { AuthenticationService } from './services/authentication.service';
import { SettingsService } from './services/settings.service';
import LabResultsActions from './store/lab-results/actions';
import NotificationActions from './store/notifications/actions';

export function dataInitializer(
  authenticationService: AuthenticationService,
  broadcastService: MsalBroadcastService,
  store: Store,
  settingsService: SettingsService,
  msalService: MsalService,
) {
  return async () => {
    await firstValueFrom(msalService.initialize());
    authenticationService.restoreActiveAccount();

    const initializeData = () => {
      settingsService.isOnboardingCompleted$
        .pipe(
          filter((isOnboardingCompleted) => !!isOnboardingCompleted),
          take(1),
        )
        .subscribe(() => {
          store.dispatch(SettingsActions.loadUserLocations());
          store.dispatch(NotificationActions.loadNotifications());
          store.dispatch(LabResultsActions.loadNutrientDefinitions());
        });
    };

    if (authenticationService.isLoggedIn()) {
      initializeData();
    } else {
      const destroy$ = new Subject<void>();
      broadcastService.msalSubject$
        .pipe(
          takeUntil(destroy$),
          filter((msg) => msg.eventType === EventType.LOGIN_SUCCESS),
        )
        .subscribe(() => {
          initializeData();
          destroy$.next();
          destroy$.complete();
        });
    }
  };
}
